import React from 'react';

export function Logo({ className = 'h-7', testId = 'brand-logo' }) {
  return (
    <img
      src="/logo.png"
      alt="KELATE — Kelantan Local Marketplace"
      data-testid={testId}
      className={`w-auto select-none ${className}`}
      draggable="false"
    />
  );
}
